import underscored from 'underscore.string/underscored';

angular.module('shared').factory('ContactBadgeService', function() {
  return {
    get: function(type, status) {
      var s, t;
      t = underscored(type);
      s = status != null ? status.toLowerCase() : void 0;
      switch (false) {
        case t !== 'prospect':
          return 'prospect-badge';
        case t !== 'non_attending_contact':
          return 'non-attending-contact-badge';
        case !(t === 'member' && s === 'active'):
          return 'member-badge';
        case !(t === 'member' && s === 'cancelled'):
          return 'cancelled-badge';
        case !(t === 'member' && s === 'suspended'):
          return 'suspended-badge';
      }
    }
  };
});
